import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { findAllImage, findAllServicePage } from "../api/apiService";
import arrowImg from "../assets/porfolioarrow.svg";
const Services = () => {
  const [hoveredService, setHoveredService] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [imageUrls, setImageUrls] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const [categories, setCategories] = useState([])
  const findData = async () => {
  try {
    const res = await findAllServicePage();
    
    if (!res?.data || res.data.length === 0) return;
    
    setCategories(res.data);
    const imagePromises = res.data.map(async (item, index) => {
      if (!item?.primaryImage) return null;
      
      try {
        const imageRes = await findAllImage(item.primaryImage);
        return imageRes?.data?.[0]?.data?.[0] || null;
      } catch (err) {
        console.error(`Error fetching image ${index}:`, err);
        return null;
      }
    });

    const images = await Promise.all(imagePromises);
    setImageUrls(images);

  } catch (error) {
    console.error("Error fetching service data:", error);
  }
};

  useEffect(() => {
    findData()
  }, [])

  return (
    <>
      {categories &&

        <section className="container mx-auto pt-24 px-4 sm:px-6 py-12">
          <h1 className="text-2xl sm:text-3xl font-bold text-center mb-10 text-[#F37934]" data-aos="zoom-in"
            data-aos-duration="800"
            data-aos-easing="ease-out">
            Our Services
          </h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories?.map((service, index) => (
              <Link
                key={index}
                to={service?.slug}
                className="group relative p-4 rounded-xl border-2 border-white cursor-pointer overflow-visible w-full max-w-xs sm:max-w-sm mx-auto h-[320px] sm:h-[350px] flex flex-col justify-between"

                style={{
                  background:
                    "linear-gradient(to bottom right, #F0F0E5, #FFFFFF, #F0F0E5)",
                }}
                onMouseEnter={() => !isMobile && setHoveredService(index)}
                onMouseLeave={() => !isMobile && setHoveredService(null)}
              >
                <div className="relative w-full h-52 sm:h-52 md:h-56 rounded-xl overflow-hidden">
                  <img
                    src={imageUrls[index]}
                    alt={service?.heading}
                    className={`w-full h-full object-cover transition-all duration-500 ${hoveredService === index && !isMobile ? "clipped-img" : ""
                      }`}
                  />
                </div>
                <div
                  className={`absolute bottom-20 left-6 w-[94%] min-h-[55px] sm:min-h-[60px]
     bg-[#F37934] text-white font-bold text-sm sm:text-lg
     flex items-center justify-center rounded-full px-3 text-center
     -rotate-[12deg] origin-bottom-left font-cinzel leading-tight
     z-50 pointer-events-none break-words whitespace-pre-line
     transition-all duration-700 ease-[cubic-bezier(0.19,1,0.22,1)]
     ${hoveredService === index && !isMobile
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 translate-y-8"
                    }`}
                >
                  {service?.heading}
                </div>

                <div className={`absolute bottom-2 right-4 z-50 flex flex-col items-end font-cinzel font-semibold
                   transition-all duration-500 ease-in-out ${hoveredService === index && !isMobile
                    ? "opacity-100 translate-x-0"
                    : "opacity-0 translate-x-8"
                  }`}>
                  <img
                    src={arrowImg}
                    alt="arrow"
                    className="w-16 h-10"
                  />
                  <span className="text-xs sm:text-sm md:text-base text-[#56453F]">
                    See The Portfolio
                  </span>
                </div>
                <div className="mt-1 text-center min-h-[50px] sm:min-h-[60px] flex items-center justify-center">
                  <h2 className={`text-base sm:text-lg max-w-sm text-[#56453F] font-semibold leading-snug text-center px-2
                  transition-opacity duration-500 ease-in-out ${hoveredService === index && !isMobile
                      ? "opacity-0"
                      : "opacity-100"
                    }`}>
                    {service?.heading}
                  </h2>
                </div>
              </Link>
            ))}

          </div>

        </section>
      }
    </>
  );
};

export default Services;
